module.exports = __webpack_public_path__ + "static/media/dropdown-arrow-dark.b36c8d0b.svg";